<div class="pagination-footer" [class.pagination-footer--flat]="flat()" [attr.aria-busy]="disabled() ? 'true' : null">
  <div class="pagination-controls">
    <div class="rows-per-page">
      <div class="rows-per-page-label body-s">{{ 'translations.global.pagination.rowsPerPage' | transloco }}</div>
      <ptl-autocomplete-search
        class="select-field"
        variant="menu"
        [options]="pageSizeMenuOptions()"
        [disabled]="disabled()"
        [searchAriaLabel]="'translations.global.pagination.rowsPerPage' | transloco"
        [ngModel]="pageSize()"
        (selectionChange)="onPageSizeChange($any($event))"
      ></ptl-autocomplete-search>
    </div>

    <div class="pagination-info body-s" aria-live="polite" aria-atomic="true">
      {{ 'translations.global.pagination.range' | transloco: { start: formattedStart(), end: formattedEnd(), total: formattedTotal() } }}
    </div>

    @if (totalPages() > 1) {
      <div class="navigation-controls" role="navigation" [attr.aria-label]="'translations.global.pagination.label' | transloco">
        <ptl-button
          [type]="'tertiary-neutral'"
          [icon]="LucideChevronLeft"
          [disabled]="currentPage() <= 1"
          (click)="onPreviousPage()"
          [attr.aria-label]="'translations.global.pagination.previousPage' | transloco"
        >
        </ptl-button>

        <div class="page-numbers">
          @for (item of pageItems(); track $index) {
            @if (item === PAGE_GAP) {
              <span class="page-gap" aria-hidden="true">…</span>
            } @else {
              <button
                type="button"
                class="page-number"
                [class.is-current]="item === currentPage()"
                [attr.aria-current]="item === currentPage() ? 'page' : null"
                [attr.aria-label]="'translations.global.pagination.page' | transloco: { page: item }"
                (click)="onPageSelect(item)"
              >
                {{ item }}
              </button>
            }
          }
        </div>

        <ptl-button
          [type]="'tertiary-neutral'"
          [icon]="LucideChevronRight"
          [disabled]="currentPage() >= totalPages()"
          (click)="onNextPage()"
          [attr.aria-label]="'translations.global.pagination.nextPage' | transloco"
        >
        </ptl-button>
      </div>
    }
  </div>
</div>
